import Icon from '@plone/volto/components/theme/Icon/Icon';
import boldSVG from '@plone/volto/icons/bold.svg';

export default function addStyleMenuFontWeight(config) {
  const { slate } = config.settings;

  slate.styleMenu = slate.styleMenu || {};
  slate.styleMenu.inlineStyles =
    slate.styleMenu.inlineStyles || [];

  slate.styleMenu.inlineStyles.push(
    {
      cssClass: 'font-weight-300',
      label: 'Light',
      icon: () => <Icon name={boldSVG} size="24px" />,
    },
    {
      cssClass: 'font-weight-400',
      label: 'Normal',
      icon: () => <Icon name={boldSVG} size="24px" />,
    },
    {
      cssClass: 'font-weight-500',
      label: 'Medium',
      icon: () => <Icon name={boldSVG} size="24px" />,
    },
    {
      cssClass: 'font-weight-600',
      label: 'Semibold',
      icon: () => <Icon name={boldSVG} size="24px" />,
    },
    {
      cssClass: 'font-weight-700',
      label: 'Bold',
      icon: () => <Icon name={boldSVG} size="24px" />,
    },
  );

  return config;
}